<div class="page-container">
    <app-header [title]="title" [back]="true"> </app-header>

    <div>
        <ng-container *ngIf="isAdmin">
            <ng-container>
                <ui-button
                    class="margin-bottom-2 all-completed-tasks-button"
                    (click)="navigateToAllTasksView()"
                    type="link"
                >
                    {{ 'components.completed-tasks.allTasks' | appTranslate }}
                    <mat-icon svgIcon="chevronRight"></mat-icon
                ></ui-button>
            </ng-container>
        </ng-container>
        <div class="app-grid">
            <ui-card [withSpacing]="false" class="columns-8 task-container" [class.loading]="isLoadingTasks">
                <app-task-checklist
                    #taskChecklist
                    [employee]="employee"
                    [tasks]="tasks"
                    (updateTasks)="updateTasks()"
                    (onScroll)="onScrollTasksList()"
                ></app-task-checklist>

                <ng-container *ngIf="!tasks.length">
                    <app-empty-state
                        [@fadeIn]
                        label="{{ 'dashboard.noTasks' | translate }}"
                        src="/assets/illustrations/cup.png"
                    ></app-empty-state>
                </ng-container>
            </ui-card>
        </div>
    </div>
</div>
